import React, { useCallback } from 'react';
import { Map } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useOptionalUscgMapContext } from 'components/MapPage/CorporateViewTabs/LayersTab/useOptionalUscgMapContext';
import type { ActionEntity } from './hooks/useScopedActionForm';
import { getActionCoordinates } from './utils/actionGeolocation';
import { formatActionTask } from './utils/actionTask';

type ActionMapButtonProps = {
  action: ActionEntity;
};

export const ActionMapButton: React.FC<ActionMapButtonProps> = ({ action }) => {
  const map = useOptionalUscgMapContext();
  const coords = getActionCoordinates(action.geolocation);
  const taskLabel = formatActionTask(action.name, action.description);

  const onClick = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation();
      if (!coords || !map?.mapView) return;
      map.setIsMapVisible(true);
      const { openActionMapPopup } = await import('./openActionMapPopup');
      await openActionMapPopup({ mapView: map.mapView, action });
    },
    [action, coords, map]
  );

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      title={coords ? 'Zoom map to action location' : 'No location set'}
      aria-label={
        coords ? `Show ${taskLabel || 'action'} on map` : 'No location set'
      }
      disabled={!coords}
      onClick={onClick}
    >
      <Map className="tw:size-4" />
    </Button>
  );
};
